// Single source of truth for the locales the dashboard React SPA supports.
// Keep this in sync with `I18n.available_locales` (config/initializers/i18n.rb)
// and the `.yml` files under app/javascript/locales/.

const SUPPORTED_LOCALES = [
  { code: 'en', label: 'EN — English' },
  { code: 'es', label: 'ES — Español' },
  { code: 'fr', label: 'FR — Français' },
  { code: 'ar', label: 'AR — العربية' },
  { code: 'zh', label: 'ZH — 中文' },
];

export const SUPPORTED_LOCALE_CODES = SUPPORTED_LOCALES.map(l => l.code);

export const DEFAULT_LOCALE = 'en';

export default SUPPORTED_LOCALES;
